import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var HobCutoutView = /** @class */ (function (_super) {
    tslib_1.__extends(HobCutoutView, _super);
    function HobCutoutView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hobcutoutPopupOpen = false;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    HobCutoutView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    HobCutoutView.prototype.created = function () {
        if (!this.$state.hobcutout)
            this.hobcutoutPopupOpen = true;
    };
    Object.defineProperty(HobCutoutView.prototype, "hobcutout", {
        get: function () {
            var _this = this;
            var hobcutout = this.$configuration.models.hobcutouts.find(function (s) { return s.code == _this.$state.hobcutout; });
            if (hobcutout == null) {
                var noHobCutout = this.$configuration.models.hobcutouts.find(function (s) { return s.code == "0"; });
                return {
                    name: null,
                    code: null,
                    handedness: null,
                    description: null,
                    image: noHobCutout.image,
                    embedMedia: null,
                    link: null,
                    drawing: null,
                    minLength: null,
                    maxLength: null,
                    minHeight: null,
                    maxHeight: null,
                    fixedDistanceFront: null,
                    step: null,
                    visibleInVertex: true,
                    sinkCount: 0,
                    length: 0,
                    width: 0,
                    height: 0,
                    rules: null,
                    warnings: null
                };
            }
            return hobcutout;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HobCutoutView.prototype, "hobcutoutMeasurementTypes", {
        get: function () {
            return {
                title: null,
                options: [
                    {
                        value: "edge",
                        text: this.$ui.t("hobcutoutToEdge"),
                        image: null,
                        embedMedia: null,
                        link: null,
                        disabled: false,
                        visible: true,
                        warnings: [],
                        messages: []
                    },
                    {
                        value: "center",
                        text: this.$ui.t("hobcutoutToCenter"),
                        image: null,
                        embedMedia: null,
                        link: null,
                        disabled: false,
                        visible: true,
                        warnings: [],
                        messages: []
                    }
                ]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HobCutoutView.prototype, "maxLength", {
        get: function () {
            var sinkSpace = this.$ui.sink.length > 0 ? this.$ui.sink.length + 100 : 0;
            return this.$ui.worktopLength - sinkSpace - (45 * 2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HobCutoutView.prototype, "hasDimensionsSet", {
        get: function () {
            return this.$state.hobcutout == '1' && this.$ui.hobcutoutLength > 0 && this.$ui.hobcutoutWidth > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HobCutoutView.prototype, "hasSpaceAvailable", {
        get: function () {
            var _this = this;
            if (this.$state.hobcutout == '0' || !this.$ui.hobcutoutLength || !this.$ui.hobcutoutWidth)
                return true;
            var availableSpaces = [
                (this.$ui.sinkDistanceLeft || this.$ui.worktopLength) - 45 - (this.$ui.sinkDistanceLeft ? this.$ui.hobcutoutMargins : 45),
                (this.$ui.sinkDistanceRight || this.$ui.worktopLength) - 45 - (this.$ui.sinkDistanceRight ? this.$ui.hobcutoutMargins : 45)
            ];
            var availableSpace = availableSpaces.find(function (s) { return s >= _this.$ui.hobcutoutLength; });
            return !!availableSpace && this.$ui.hobcutoutWidth <= (this.$ui.worktopWidth - (45 * 2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HobCutoutView.prototype, "inputClasses", {
        get: function () {
            var classes = [];
            if (this.$ui.hobcutoutHasPlacementError) {
                classes.push("invalid");
            }
            return classes;
        },
        enumerable: true,
        configurable: true
    });
    HobCutoutView = tslib_1.__decorate([
        Component
    ], HobCutoutView);
    return HobCutoutView;
}(Vue));
export default HobCutoutView;
